import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {User} from '../app/utilities/user';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  private readonly baseURL = environment.baseApiUrl;

  // in-memory caches
  private allUsers$?: Observable<any>;
  private userInfoCache = new Map<string, Observable<User>>();

  constructor(private httpClient: HttpClient) {
  }

    getAllUsers()
    {
    // caching all users list
    if (!this.allUsers$) {
      this.allUsers$ = this.httpClient
        .get<any>(this.baseURL+'User/GetAllUsers')
        .pipe(shareReplay(1));
    }
    return this.allUsers$;
  }

    getUserInfo(userId:string)
    {
    // per-user caching keyed by userId
    const key = userId ?? '';
    const cached = this.userInfoCache.get(key);
    if (cached) {
      return cached;
    }
    const req$ = this.httpClient
      .get<User>(this.baseURL+'User/GetUserInfo?userId='+userId)
      .pipe(shareReplay(1));
    this.userInfoCache.set(key, req$);
    return req$;
  }

  createOrUpdateUser(userData: any) {
    return this.httpClient.post<User>(this.baseURL + 'User/CreateOrUpdateUser', userData)
      .pipe(
        tap(() => {
          // Clear the cache after successful update
          this.clearCache();
        })
      );
  }

  // Method to clear all caches
  clearCache() {
    this.allUsers$ = undefined;
    this.userInfoCache.clear();
  }
}
